/* unplugin-vue-components disabled */import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { Toast, Dialog } from 'vant';
import * as userService from '@/services/user';
import yxhJsBridge from '@/shared/yxhJsBridge';
import { detectEnv } from '@/shared/detect';
import TrackingData from '@/shared/reportDataTracking';
import { debounce } from 'lodash-es';
import { useUserStore } from '@/stores/modules/user';
var SendCaptchaStatus = /*#__PURE__*/ function(SendCaptchaStatus) {
    SendCaptchaStatus[SendCaptchaStatus["UN_SEND"] = 0] = "UN_SEND";
    SendCaptchaStatus[SendCaptchaStatus["SENDING"] = 1] = "SENDING";
    SendCaptchaStatus[SendCaptchaStatus["COUNTING"] = 2] = "COUNTING";
    SendCaptchaStatus[SendCaptchaStatus["COUNT_END"] = 3] = "COUNT_END";
    return SendCaptchaStatus;
}(SendCaptchaStatus || {});
export default /*#__PURE__*/ _defineComponent({
    __name: 'close-account',
    setup: function(__props) {
        var userStore = useUserStore();
        console.log(detectEnv, 'detectEnv');
        var isApp = computed(function() {
            return detectEnv.android;
        });
        var form = reactive({
            phone: '',
            captcha: ''
        });
        var disabled = computed(function() {
            return !/^[1-9]\d{9}$/.test(form.phone);
        });
        var inputFocus = reactive({
            phoneInput: false,
            captchaInput: false
        });
        var sendCaptchaStatus = ref(0);
        var countdown = ref(null);
        var validateForm = function() {
            if (!form.phone.length) {
                Toast('Introduce su número de teléfono');
                return false;
            }
            if (disabled.value) {
                Toast('Introduce 10 dígitos.');
                return false;
            }
            return true;
        };
        // @exposed-api
        var send = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function() {
                var _userStore_commonData, e;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!validateForm()) {
                                TrackingData.trackClick(_object_spread_props(_object_spread({}, userStore.commonData), {
                                    taskHandler: 'account_cancel_screen-verificationcode_apply',
                                    taskState: 0
                                }));
                                return [
                                    2
                                ];
                            }
                            TrackingData.trackClick(_object_spread_props(_object_spread({}, userStore.commonData), {
                                taskHandler: 'account_cancel_screen-verificationcode_apply',
                                taskState: 1
                            }));
                            sendCaptchaStatus.value = 1;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                userService.queryCaptchaByPhone({
                                    mobileNumber: form.phone,
                                    appTitle: (_userStore_commonData = userStore.commonData) === null || _userStore_commonData === void 0 ? void 0 : _userStore_commonData.appTitle
                                })
                            ];
                        case 2:
                            _state.sent();
                            sendCaptchaStatus.value = 2;
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            sendCaptchaStatus.value = 3;
                            return [
                                3,
                                4
                            ];
                        case 4:
                            if (sendCaptchaStatus.value === 2) {
                                nextTick(function() {
                                    var _countdown_value;
                                    (_countdown_value = countdown.value) === null || _countdown_value === void 0 ? void 0 : _countdown_value.start();
                                });
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function send() {
                return _ref.apply(this, arguments);
            };
        }();
        /**
 * count down finish
 */ var onCountdownFinish = function() {
            var _countdown_value;
            sendCaptchaStatus.value = 3;
            (_countdown_value = countdown.value) === null || _countdown_value === void 0 ? void 0 : _countdown_value.reset();
        };
        var durationTime = ref(0);
        // onMounted(() => {
        //   durationTime.value = Date.now();
        //   TrackingData.trackPageEnter({
        //      ...userStore.commonData,
        //     taskHandler: 'account_cancel_screen-pagein',
        //   });
        // });
        /**
 * submit phone number
 */ var onSubmit = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function() {
                var _userStore_commonData, _ref, resultMsg, calledOff, err;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!validateForm()) {
                                TrackingData.trackClick(_object_spread_props(_object_spread({}, userStore.commonData), {
                                    taskHandler: 'account_cancel_screen-login_click',
                                    taskState: 0
                                }));
                                return [
                                    2
                                ];
                            }
                            if (form.captcha.length < 4) {
                                Toast('Introduce el código de verificación correcto');
                                TrackingData.trackClick(_object_spread_props(_object_spread({}, userStore.commonData), {
                                    taskHandler: 'account_cancel_screen-login_click',
                                    taskState: 0
                                }));
                                return [
                                    2
                                ];
                            }
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            yxhJsBridge.webOccupationBack('1');
                            console.log('webOccupationBack');
                            window.localBackPressed = function() {
                                console.log('localBackPressed');
                            };
                            return [
                                4,
                                userService.checkH5VerifyCodeAndSignOut({
                                    mobileNumber: form.phone,
                                    authToken: form.captcha,
                                    appTitle: (_userStore_commonData = userStore.commonData) === null || _userStore_commonData === void 0 ? void 0 : _userStore_commonData.appTitle
                                })
                            ];
                        case 2:
                            _ref = _state.sent(), resultMsg = _ref.resultMsg, calledOff = _ref.calledOff;
                            if (!calledOff) {
                                Toast(resultMsg);
                                TrackingData.trackClick(_object_spread_props(_object_spread({}, userStore.commonData), {
                                    taskHandler: 'account_cancel_screen-login_click',
                                    taskState: 0
                                }));
                                return [
                                    2
                                ];
                            }
                            TrackingData.trackClick(_object_spread_props(_object_spread({}, userStore.commonData), {
                                taskHandler: 'account_cancel_screen-login_click',
                                taskState: 1,
                                eventIntervalSpan: Date.now() - durationTime.value
                            }));
                            if (detectEnv.webview) {
                                yxhJsBridge.delAccountSus();
                                yxhJsBridge.webOccupationBack('0');
                                window.localBackPressed = function() {};
                            }
                            Dialog({
                                title: 'Nota',
                                message: 'Operación exitosa',
                                confirmButtonText: 'OK'
                            }).then(function() {
                                window.location.reload();
                            });
                            return [
                                3,
                                4
                            ];
                        case 3:
                            err = _state.sent();
                            TrackingData.trackClick(_object_spread_props(_object_spread({}, userStore.commonData), {
                                taskHandler: 'account_cancel_screen-login_click',
                                taskState: 0
                            }));
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function onSubmit() {
                return _ref.apply(this, arguments);
            };
        }();
        // onBeforeUnmount(() => {
        //   TrackingData.trackPageEnd({
        // ...userStore.commonData,
        //     taskHandler: 'account_cancel_screen-pageout',
        //   });
        // });
        /**
 * Enter the phone number to report it, 3s
 */ var onChangePhoneNumber = debounce(function() {
            TrackingData.trackInput(_object_spread_props(_object_spread({}, userStore.commonData), {
                taskHandler: 'account_cancel_screen-phonenumber-input'
            }));
        }, 3000, {
            leading: true,
            trailing: false
        });
        /**
 * Enter the captcha number to report it, 3s
 */ var onChangeCaptchaNumber = debounce(function() {
            TrackingData.trackInput(_object_spread_props(_object_spread({}, userStore.commonData), {
                taskHandler: 'account_cancel_screen-verificationcode_input'
            }));
        }, 3000, {
            leading: true,
            trailing: false
        });
        onUnmounted(function() {
            window.localBackPressed = function() {};
        });
        return {
            __sfc: true,
            SendCaptchaStatus: SendCaptchaStatus,
            userStore: userStore,
            isApp: isApp,
            form: form,
            disabled: disabled,
            inputFocus: inputFocus,
            sendCaptchaStatus: sendCaptchaStatus,
            countdown: countdown,
            validateForm: validateForm,
            send: send,
            onCountdownFinish: onCountdownFinish,
            durationTime: durationTime,
            onSubmit: onSubmit,
            onChangePhoneNumber: onChangePhoneNumber,
            onChangeCaptchaNumber: onChangeCaptchaNumber
        };
    }
});
